export default class BillingItemFile {
    constructor() {
        this.id;
        this.billingItemId;
        this.fileId;
        this.accountFileType;
        this.validUntil;
        this.isVerified;
        this.verifiedByUserId;
        this.verfiedByUser;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.billingItemId = setEntity.billingItemId;
        this.fileId = setEntity.fileId;
        this.accountFileType = setEntity.accountFileType;
        this.validUntil = setEntity.validUntil;
        this.isVerified = setEntity.isVerified;
        this.verifiedByUserId = setEntity.verifiedByUserId;
        this.verfiedByUser = setEntity.verfiedByUser;
        return this;
    }
}
